// extracted by mini-css-extract-plugin
export default {"wrap":"YouTubeLogo_wrap__scG6F","logo":"YouTubeLogo_logo__0OxxK","text":"YouTubeLogo_text__oNWo3","liveBadge":"YouTubeLogo_liveBadge__WvtFz","liveDot":"YouTubeLogo_liveDot__GKYT3"};